import styled from 'styled-components'

export const LinkContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 10px;
  padding-bottom: 10px;

  .link-row {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    &.header-navigation {
      padding: 10px 0;
      justify-content: flex-end;
      align-content: center;
      color: ${ (props) => props.theme.colors['panel-inner-border'] } @media
          ${ (props) => props.theme.breakpoints.devices.max.sm },
        print {
        > button {
          border: none;
          display: block;
        }
      }
    }

    &.half-size {
      width: 50%;

      div > button {
        border: none;
        display: block;
        width: auto;
      }

      div:nth-child(1) > button {
        margin-bottom: 10px;
      }

      div:nth-child(2) > button {
        padding-right: 6px;
        padding-left: 7px;
        display: flex;
        padding-top: 4px;
        justify-content: space-between;

        @media ${ (props) => props.theme.breakpoints.devices.max.md }, print {
          padding-top: 3px;
          > span {
            padding-left: 10px;
          }
        }
      }
    }
  }

  @media ${ (props) => props.theme.breakpoints.devices.min.sm }, print {
    margin-bottom: 30px;
  }
`
